import { BILLING_SUBSCRIPTION_STATUS } from '@/const/shared';
import { SubscriptionGraceBanner } from './ui/SubscriptionGraceBanner';
import { SubscriptionSuspendedBanner } from './ui/SubscriptionSuspendedBanner';
import { SubscriptionCancelledBanner } from './ui/SubscriptionCancelledBanner';
import { getBillingSubscriptionStatus, isEnterprisePlanType } from '@/helpers/billingHelpers';
import { useUser } from '@/context/userContext';
import { TrialModeBanner } from './ui/TrialModeBanner';

// TODO v23.0.0: find a better solution to handle all condition in all place for all cases.
const SUBSCRIPTION_STATUS_BANNER_MAP = {
  [BILLING_SUBSCRIPTION_STATUS.GRACE]: (isMasterAdmin: boolean) => {
    return isMasterAdmin && <SubscriptionGraceBanner />;
  },
  [BILLING_SUBSCRIPTION_STATUS.SUSPENDED]: () => {
    return <SubscriptionSuspendedBanner />;
  },
  [BILLING_SUBSCRIPTION_STATUS.CANCELLED]: () => {
    return <SubscriptionCancelledBanner />;
  },
};

export const OrganizationSubscriptionStatusBanner = () => {
  const { user, isMasterAdminRole, isTrialAdmin } = useUser();
  const isEnterprisePlan = isEnterprisePlanType(user);

  if (isEnterprisePlan) return;

  // Banner for trial mode
  if (isTrialAdmin) {
    return <TrialModeBanner />;
  }

  // Banners for all inactive subscription states
  const subscriptionStatus = getBillingSubscriptionStatus(user);
  const getRenderBannerCondition = SUBSCRIPTION_STATUS_BANNER_MAP[subscriptionStatus];
  const banner = getRenderBannerCondition?.(isMasterAdminRole);

  return <>{banner}</>;
};
